class Modal {


	constructor(){
		this.body      = document.querySelector('body');
		this.initialBodyState = null;
		this._init();
	}
  
  
	_init(){
		document.addEventListener('click', 
			(event) => this._onTriggerClick(event)
		);
	}

	_onTriggerClick(event){
		let element = this._getElementClicked(event);
		
		if(element){
			let componentName = element.getAttribute('data-modal-trigger');
			
			if(componentName){
				let modalElement = document.querySelector('[data-modal="'+componentName+'"]');
				
				if(modalElement){
					let src = element.getAttribute('data-modal-src');
					this._toggleModal(modalElement, src, event);
				}
			}
		}

	}

	_toggleModal(modalElement, src, event){
		
		this._cleanModal(modalElement);
		
		if(src){
			let modalContent = modalElement.querySelector('[data-modal-content]');
			modalContent.setAttribute('src', src);
		}
		
		// Stop propagation of close primary nav event
		event.stopPropagation();
		
		// lock body
		const currentBodyState = this.body.getAttribute('data-state');
		if(currentBodyState  === 'locked-for-header-primary'){
			this.initialBodyState = currentBodyState;
		}
		if(currentBodyState === 'locked-for-modal' && 
		this.initialBodyState === 'locked-for-header-primary'){
			this.body.setAttribute('data-state', 'locked-for-header-primary');
		} else {
			this._toggleState(this.body, 'locked-for-modal', 'unlocked');
		}

		// toggle modal
		this._toggleState(modalElement, 'open', 'closed');

		// toggle keyboard nav
		this._toggleKeyboardNav(modalElement);

	}

	_getElementClicked(event){
		let triggers = document.querySelectorAll('[data-modal-trigger]');
		let element  = event.target;
		let index    = -1;
		
		while(element && (index = Array.prototype.indexOf.call(triggers, element)) === -1 ){
			element = element.parentElement;
		}
		return (index !== -1) ? element: null;
	}


	_toggleState(elem, one, two){
		const newState = elem.getAttribute('data-state') === one ? two : one;
  	elem.setAttribute('data-state', newState);
	}
	
	_cleanModal(modalElement){
		let modalContent = modalElement.querySelector('[data-modal-content]');
		if(modalContent){
			modalContent.setAttribute('src', '');
			modalContent.innerHTML = '';
		}
	}

	_toggleKeyboardNav(modalElement){
		const isActive = (modalElement.getAttribute('data-state') === 'open');
		
		if(isActive){
			this.functionReference = this._onKeyDown.bind(this, modalElement);
			document.addEventListener('keydown', this.functionReference);
		} else {
			document.removeEventListener('keydown', this.functionReference);
		}
	}

	_onKeyDown(modalElement, e){
		switch (e.keyCode) {
			case 27:
			this._toggleModal(modalElement);
			break;
			default:
			break;
		}
	}
}

export const modal = new Modal();